export default __webpack_public_path__ + "static/media/README.01b56df2.md";